/* eslint-disable react/prop-types */
import React from 'react';
import './Dropdown.scss';
import { DropdownProps } from '../../types';

const Dropdown: React.FC<DropdownProps> = ({ data, index }) => {
  return (
    <div className="dropdown--general flex--4">
      {data.map((item, i) => (
        <div
          className={`flex--2 pointer row`}
          key={i}
          onClick={(e) => {
            item.fn(index);
            e.stopPropagation();
          }}
        >
          {typeof item.icon === 'string' ? <img src={item.icon} alt={item.text} /> : item.icon}
          <p style={{ color: item.color || '' }}>{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default Dropdown;
